<template>
  <div class="row">
    <div class="col">
      <div class="card bg-white">
        <div class="card-header bg-gray-100">
          <p class="text-semibold no-margin">Motorista | {{ id }}</p>
          <div class="heading-elements">
            <i
              class="fas fa-long-arrow-alt-left position-left"
              @click="voltar()"
              style="cursor: pointer"
            ></i>
          </div>
        </div>
        <div class="box-body">
          <div class="form-group col-12 col-md-6">
            <label for="nome">Nome: &nbsp;&nbsp;&nbsp;</label>
            {{ registro.nome }}
          </div>
          <div class="form-group col-12 col-md-6">
            <label for="status_desc">Status: &nbsp;&nbsp;&nbsp;</label>
            <span
              class="label"
              v-bind:class="{
                'label-success': registro.idc_status === 1,
                'label-danger': [2, 11].includes(registro.idc_status),
                'label-warning': registro.idc_status === 3,
                'label-info': [4, 5, 6].includes(registro.idc_status),
                'label-default': ![1, 2, 3, 4, 11].includes(registro.idc_status)
              }"
            >
              {{ registro.status_desc }}
            </span>
          </div>
          <div class="form-group col-12 col-md-6">
            <label for="cpf">CPF: &nbsp;&nbsp;&nbsp;</label>
            {{ registro.cpf }}
          </div>
          <div class="form-group col-12 col-md-6">
            <label for="termo_aceito_desc">Termo: &nbsp;&nbsp;&nbsp;</label>
            <span
              class="label"
              v-bind:class="{
                'label-success': registro.idc_termo_aceito === 1,
                'label-danger': registro.idc_termo_aceito === 2,
                'label-warning': registro.idc_termo_aceito === 3,
                'label-default': ![1, 2, 3].includes(registro.idc_termo_aceito)
              }"
            >
              {{ registro.termo_aceito_desc }}
            </span>
          </div>
          <div class="form-group col-12 col-md-6">
            <label for="email">E-mail: &nbsp;&nbsp;&nbsp;</label>
            {{ registro.email }}
          </div>
          <div class="form-group col-12 col-md-6">
            <label for="tel_celular">Telefone: &nbsp;&nbsp;&nbsp;</label>
            {{ registro.tel_celular }}
          </div>
          <div class="form-group col-12 col-md-6">
            <label for="end_cep">CEP: &nbsp;&nbsp;&nbsp;</label>
            {{ registro.end_cep }}
          </div>
          <div class="form-group col-12 col-md-6">
            <label for="end_logradouro">Logradouro: &nbsp;&nbsp;&nbsp;</label>
            {{ registro.end_logradouro }}
          </div>
          <div class="form-group col-12 col-md-6">
            <label for="end_numero">Número: &nbsp;&nbsp;&nbsp;</label>
            {{ registro.end_numero }}
          </div>
          <div class="form-group col-12 col-md-6">
            <label for="end_complemento">Complemento: &nbsp;&nbsp;&nbsp;</label>
            {{ registro.end_complemento }}
          </div>
          <div class="form-group col-12 col-md-6">
            <label for="end_bairro">Bairro: &nbsp;&nbsp;&nbsp;</label>
            {{ registro.end_bairro }}
          </div>
          <div class="form-group col-12 col-md-6">
            <label for="end_cidade">Cidade: &nbsp;&nbsp;&nbsp;</label>
            {{ registro.end_cidade }}
          </div>
          <div class="form-group col-12 col-md-6">
            <label for="end_uf">UF: &nbsp;&nbsp;&nbsp;</label>
            {{ registro.end_uf }}
          </div>
          <div class="form-group col-12 col-md-6">
            <label for="end_pais">País: &nbsp;&nbsp;&nbsp;</label>
            {{ registro.pais.descricao }}
          </div>
          <div class="form-group col-12 col-md-6">
            <label for="end_latitude">Latitude: &nbsp;&nbsp;&nbsp;</label>
            {{ registro.end_latitude }}
          </div>
          <div class="form-group col-12 col-md-6">
            <label for="end_longitude">Longitude: &nbsp;&nbsp;&nbsp;</label>
            {{ registro.end_longitude }}
          </div>
          <div class="form-group col-12 col-md-6">
            <label for="idc_equipamento_desc">Equipamento: &nbsp;&nbsp;&nbsp;</label>
            <span
              class="label"
              v-bind:class="{
                'label-success': registro.idc_equipamento === 1,
                'label-danger': registro.idc_equipamento === 2,
                'label-warning': registro.idc_equipamento === 3
              }"
            >
              {{ registro.idc_equipamento_desc }}
            </span>
          </div>
          <div class="form-group col-12 col-md-6">
            <label for="idc_equipamento_desc">Código de importação: &nbsp;&nbsp;&nbsp;</label>
            {{ registro.codigo_importacao }}
          </div>
          <div class="form-group col-12 col-md-6">
            <label for="idc_equipamento_desc">Aceita receber mensagens no whatsapp ? &nbsp;&nbsp;&nbsp;</label>
            <span
              class="label"
              v-bind:class="{
                'label-success': registro.aceita_receber_whatsapp === true,
                'label-danger': registro.aceita_receber_whatsapp === false
              }"
            >
              {{ registro.aceita_receber_whatsapp ? "Sim" : "Não" }}
            </span>
          </div>
          <div class="form-group col-12 col-md-6">
            <label for="idc_equipamento_desc">Primeiro acesso: &nbsp;&nbsp;&nbsp;</label>
            <span
              class="label"
              v-bind:class="{
                'label-success': registro.primeiro_acesso === true,
                'label-danger': registro.primeiro_acesso === false
              }"
            >
              {{ registro.primeiro_acesso ? "Sim" : "Não" }}
            </span>
          </div>
          <div class="form-group col-12 col-md-6">
            <label>Gênero: &nbsp;&nbsp;&nbsp;</label>
            {{ registro.genero || "Não informado" }}
          </div>
          <div class="form-group col-12 col-md-6">
            <label for="end_longitude">Observação: &nbsp;&nbsp;&nbsp;</label>
            {{ registro.observacao || '-' }}
          </div>
        </div>
        <div class="box-footer text-center">
          <div class="btn-group">
            <button type="button" class="btn btn-warning" @click="voltar()">
              Voltar
            </button>
            <button type="button" class="btn btn-info" @click="editar()">
              Editar
            </button>
          </div>

          <div
            class="btn-group"
            style="padding-left: 15px"
            v-show="registro.idc_status === 3"
          >
            <button type="button" class="btn btn-success" @click="aprovar()">
              Aprovar
            </button>
            <button type="button" class="btn btn-danger" @click="reprovar()">
              Reprovar
            </button>
            <button
              type="button"
              class="btn bg-navy"
              @click="alterarPendente()"
            >
              Alterar p/ Pendente
            </button>
          </div>

          <div
            class="btn-group"
            style="padding-left: 15px"
            v-show="registro.idc_status === 13"
          >
            <button type="button" class="btn btn-success" @click="preAprovar()">
              Pré-aprovar
            </button>
            <button
              type="button"
              class="btn bg-navy"
              @click="alterarPendente()"
            >
              Alterar p/ Pendente
            </button>
          </div>

          <button
            type="button"
            class="btn bg-gray"
            @click="gerarLinkAceiteTermo()"
          >
            Link Aceite Termo
          </button>
        </div>
      </div>
      <br />
      <div class="box box-primary">
        <div class="box-header">
          <i class="fas fa-clipboard"></i>
          <h3 class="box-title">Informações Adicionais</h3>
        </div>
        <div class="box-body">
          <div class="form-group col-12 col-md-6">
            <label>Veículo: &nbsp;&nbsp;&nbsp;</label>
            {{
              registro.complemento ? registro.complemento.veiculo : "-"
            }}
          </div>
          <div class="form-group col-12 col-md-6">
            <label>Encosto de cabeça: &nbsp;&nbsp;&nbsp;</label>
            {{ registro.complemento && registro.complemento.encosto_cabeca_desc ? registro.complemento.encosto_cabeca_desc : "-" }}
          </div>
          <div class="form-group col-12 col-md-6">
            <label>Veículo próprio: &nbsp;&nbsp;&nbsp;</label>
            <span
              class="label"
              v-bind:class="{
                'label-success': registro.complemento && registro.complemento.idc_veiculo_proprio === 1,
                'label-danger': registro.complemento && registro.complemento.idc_veiculo_proprio === 0,
                'label-warning': !registro.complemento || ![1, 0].includes(registro.complemento.idc_veiculo_proprio)
              }"
            >
              {{
                registro.complemento && [1, 0].includes(registro.complemento.idc_veiculo_proprio)
                  ? (registro.complemento.idc_veiculo_proprio ? "Sim" : "Não")
                  : "Não informado"
              }}
            </span>
          </div>
          <div class="form-group col-12 col-md-6">
            <label>Motorista Kovi: &nbsp;&nbsp;&nbsp;</label>
            <span
              class="label"
              v-bind:class="{
                'label-success': registro.complemento && registro.complemento.idc_motorista_kovi === true,
                'label-danger': registro.complemento && registro.complemento.idc_motorista_kovi === false,
                'label-warning': !registro.complemento || ![true, false].includes(registro.complemento.idc_motorista_kovi)
              }"
            >
              {{
                registro.complemento && [true, false].includes(registro.complemento.idc_motorista_kovi)
                  ? (registro.complemento.idc_motorista_kovi ? "Sim" : "Não")
                  : "Não informado"
              }}
            </span>
          </div>
          <div class="form-group col-12 col-md-6">
            <label>Posse do veículo: &nbsp;&nbsp;&nbsp;</label>
            {{ registro.complemento && registro.complemento.posse_veiculo_desc ? registro.complemento.posse_veiculo_desc : "-" }}
          </div>
        </div>
        <div class="box-footer text-center">
          <button
            type="button"
            class="btn btn-sm btn-info"
            @click="editarComplemento()"
          >
            Editar
          </button>
        </div>
      </div>
      <br />
      <div class="box box-primary">
        <div class="box-header">
          <i class="fas fa-clipboard"></i>
          <h3 class="box-title">Dados Aplicativos</h3>
          <button
            class="btn btn-sm btn-primary btn-novo"
            @click="editarAplicativo('new')"
            style="width: 33px; float: right"
            data-tooltip="Adicionar aplicativo"
          >
            <i class="fa fa-plus" aria-hidden="true"></i>
          </button>
        </div>
        <div class="box-body">
          <div
            class="row"
            v-for="item in aplicativos"
            v-bind:key="item.cd_aplicativo"
            style="padding-top: 10px; border-bottom: 1px solid #f39c12; margin-right: 0; margin-left: 0;"
          >
            <div class="form-group col-12 col-md-6">
              <label for="end_longitude">Aplicativo: &nbsp;&nbsp;&nbsp;</label>
              {{ item.aplicativo ? item.aplicativo.descricao : "-" }}
            </div>
            <div class="form-group col-12 col-md-6">
              <label for="nota_motorista"
                >Tempo de App: &nbsp;&nbsp;&nbsp;</label
              >
              {{ item.tempo_aplicativo }}
            </div>
            <div class="form-group col-12 col-md-6">
              <label for="nota_motorista">Avaliação: &nbsp;&nbsp;&nbsp;</label>
              {{ item.nota_motorista }}
            </div>
            <div class="form-group col-12 col-md-6">
              <label for="viagens_realizadas"
                >Viagens Realizadas: &nbsp;&nbsp;&nbsp;</label
              >
              {{ item.viagens_realizadas }}
            </div>
            <div class="form-group col-12 col-md-6">
              <label for="aplicativoCategoria"
                >Categoria: &nbsp;&nbsp;&nbsp;</label
              >
              {{
                item.aplicativoCategoria
                  ? item.aplicativoCategoria.descricao
                  : "-"
              }}
            </div>
            <div class="form-group col-12 col-md-6">
              <label for="aplicativoSegmento"
                >Segmentos: &nbsp;&nbsp;&nbsp;</label
              >
              {{
                item.aplicativoSegmento
                  ? item.aplicativoSegmento.descricao
                  : "-"
              }}
            </div>
            <div class="form-group col-12 col-md-6">
              <label for="status_desc">Status: &nbsp;&nbsp;&nbsp;</label>
              <span
                class="label"
                v-bind:class="{
                  'label-success': registro.idc_status === 1,
                  'label-warning': registro.idc_status === 2,
                  'label-default': ![1, 2].includes(registro.idc_status)
                }"
                >{{ registro.status_desc }}</span
              >
            </div>
            <div class="form-group col-12 col-md-6">
              <label for="end_longitude"
                >Status Perfil: &nbsp;&nbsp;&nbsp;</label
              >
              <span
                class="label"
                v-bind:class="{
                  'label-danger': [1, 4].includes(item.idc_imgem_perfil),
                  'label-warning': item.idc_imgem_perfil === 2,
                  'label-success': item.idc_imgem_perfil === 3,
                  'label-default': ![1, 2, 3, 4].includes(item.idc_imgem_perfil)
                }"
                >{{ item.imgem_perfil_desc }}</span
              >
            </div>
            <div class="form-group col-12 col-md-12 text-center">
              <div class="btn-group" style="padding-left: 15px">
                <button
                  type="button"
                  class="btn btn-sm btn-warning"
                  @click="abrirImagem(item.imgem_perfil)"
                  v-show="[2, 3, 4].includes(item.idc_imgem_perfil)"
                >
                  Visualizar Imagem Perfil
                </button>
                <button
                  type="button"
                  class="btn btn-sm btn-success"
                  @click="avaliarPerfil(item.cd_aplicativo)"
                  v-show="[2, 3, 4].includes(item.idc_imgem_perfil)"
                >
                  Avaliar Perfil
                </button>
                <button
                  type="button"
                  class="btn btn-sm btn-info"
                  @click="editarAplicativo(item.cd_aplicativo)"
                >
                  Editar
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
      <br />
      <div class="box box-primary">
        <div class="box-header">
          <i class="fas fa-clipboard"></i>
          <h3 class="box-title">Equipamento</h3>
          <button
            class="btn btn-sm btn-primary btn-novo"
            @click="vincularEquipamento()"
            style="width: 33px; float: right"
            data-tooltip="Vincular equipamento"
          >
            <i class="fa fa-plus" aria-hidden="true"></i>
          </button>
        </div>
        <div class="box-body div-table">
          <div class="row div-table-head">
            <div class="col-2 col-md-2 col-sm-2 col-xs-2"><b>Código</b></div>
            <div class="col-1 col-md-1 col-sm-1 col-xs-1"><b>Player</b></div>
            <div class="col-2 col-md-2 col-sm-2 col-xs-2"><b>Número do Frame</b></div>
            <div class="col-1 col-md-1 col-sm-1 col-xs-1"><b>Status</b></div>
            <div class="col-2 col-md-2 col-sm-2 col-xs-2"><b>Criado em</b></div>
            <div class="col-2 col-md-2 col-sm-2 col-xs-2">
              <b>Alterado em</b>
            </div>
          </div>
          <div
            class="row"
            v-for="(item, index) in registro.motorista_equipamento"
            v-bind:key="item.cd_equipamento + '-' + index"
          >
            <div class="col-2 col-md-2 col-sm-2 col-xs-2">
              <a href="#" @click="abrirEquipamento(item.cd_equipamento)">{{
                item.cd_equipamento
              }}</a>
            </div>
            <div class="col-1 col-md-1 col-sm-1 col-xs-1">
              <a href="#" @click="abrirEquipamento(item.cd_equipamento)">{{
                item.equipamento ? item.equipamento.cd_player : "-"
              }}</a>
            </div>
            <div class="col-2 col-md-2 col-sm-2 col-xs-2">
              {{item.equipamento ? item.equipamento.mac_address : "-"}}
            </div>
            <div class="col-1 col-md-1 col-sm-1 col-xs-1">
              <span
                class="label"
                v-bind:class="{
                  'label-success': item.idc_status === 1,
                  'label-warning': item.idc_status === 2
                }"
                >{{ item.status_desc }}</span
              >
            </div>
            <div class="col-2 col-md-2 col-sm-2 col-xs-2">
              {{ formatarData(item.created_at) }}
            </div>
            <div class="col-3 col-md-3 col-sm-3 col-xs-3">
              {{ formatarData(item.updated_at) }}
            </div>
            <div class="col-1 col-md-1 col-sm-1 col-xs-1">
              <a
                @click="removerEquipamento(item.cd_equipamento, item.id_player)"
                v-show="item.idc_status === 1"
                class="btn btn-xs btn-danger legitRipple"
                data-tooltip="Remover equipamento do motorista"
                data-delay="500"
                data-hasqtip="1"
              >
                <span class="fa fa-trash"></span>
              </a>
            </div>
          </div>
        </div>
      </div>
      <br />
      <div class="box box-primary">
        <div class="box-header">
          <i class="fas fa-clipboard"></i>
          <h3 class="box-title">Aceite Termo</h3>
        </div>
        <div class="box-body div-table">
          <div class="row div-table-head">
            <div class="col-4 col-md-4 col-sm-4 col-xs-4"><b>Data</b></div>
            <div class="col-4 col-md-4 col-sm-4 col-xs-4"><b>IP Origem</b></div>
            <div class="col-4 col-md-4 col-sm-4 col-xs-4"><b>Aceite</b></div>
          </div>
          <div
            class="row"
            v-for="item in aceite_termo_items"
            v-bind:key="item.cd_aceite"
          >
            <div class="col-4 col-md-4 col-sm-4 col-xs-4">
              {{ formatarData(item.dt_registro) }}
            </div>
            <div class="col-4 col-md-4 col-sm-4 col-xs-4">
              {{ item.ip_registro }}
            </div>
            <div class="col-4 col-md-4 col-sm-4 col-xs-4">
              <span
                class="label"
                v-bind:class="{
                  'label-success': item.idc_aceito === 1,
                  'label-danger': item.idc_aceito === 2
                }"
                >{{ item.idc_aceito_desc }}</span
              >
            </div>
          </div>
        </div>
      </div>
      <br />
      <div class="box box-primary">
        <div class="box-header">
          <i class="fas fa-clipboard"></i>
          <h3 class="box-title">Agendamentos</h3>
          <button
            class="btn btn-sm btn-primary btn-novo"
            @click="novoAgendamento()"
            style="width: 33px; float: right"
            data-tooltip="Novo Agendamento"
          >
            <i class="fa fa-plus" aria-hidden="true"></i>
          </button>
        </div>
        <div class="box-body div-table">
          <div class="row div-table-head">
            <div class="col-3 col-md-3 col-sm-3 col-xs-3"><b>Código</b></div>
            <div class="col-3 col-md-3 col-sm-3 col-xs-3"><b>Ponto Apoio</b></div>
            <div class="col-3 col-md-3 col-sm-3 col-xs-3"><b>Data Agendada</b></div>
            <div class="col-3 col-md-3 col-sm-3 col-xs-3"><b>Status</b></div>
          </div>
          <div
            class="row"
            v-for="item in agendamentos"
            v-bind:key="item.cd_agendamento"
          >
            <div class="col-3 col-md-3 col-sm-3 col-xs-3">
              {{ item.cd_agendamento }}
            </div>
            <div class="col-3 col-md-3 col-sm-3 col-xs-3">
              {{ item.cd_ponto_apoio }}
            </div>
            <div class="col-3 col-md-3 col-sm-3 col-xs-3">
              {{ formatarData(item.dt_agendada) }}
            </div>
            <div class="col-2 col-md-2 col-sm-2 col-xs-2">
              <span
                class="label"
                v-bind:class="{
                  'label-warning': item.idc_status === 1,
                  'label-info': item.idc_status === 2,
                  'label-default': item.idc_status === 3,
                  'label-success': item.idc_status === 4,
                  'label-danger': [5,9].includes(item.idc_status)
                }"
              >{{ item.status_desc }}</span>
            </div>
            <div class="col-1 col-md-1 col-sm-1 col-xs-1">
              <a
                @click="editarAgendamento(item.cd_agendamento)"
                v-show="[1,2,3].includes(item.idc_status)"
                class="btn btn-xs btn-warning legitRipple"
                data-tooltip="Editar agendamento"
                data-delay="500"
                data-hasqtip="1"
              >
                <span class="glyphicon glyphicon-pencil"></span>
              </a>
            </div>
          </div>
        </div>
      </div>
      <br />
      <div class="box box-primary">
        <div class="box-header">
          <i class="fas fa-clipboard"></i>
          <h3 class="box-title">Apuração Mensal</h3>
        </div>
        <div class="box-body div-table">
          <div class="row div-table-head">
            <div class="col-6 col-md-6 col-sm-6 col-xs-6">
              <b>Enviado em</b>
            </div>
            <div class="col-6 col-md-6 col-sm-6 col-xs-6">
              <b>Nº Viagens</b>
            </div>
          </div>
          <div
            class="row"
            v-for="item in historico_apuracao"
            v-bind:key="item.cd_apuracao"
          >
            <div class="col-6 col-md-6 col-sm-6 col-xs-6">
              {{ formatarData(item.created_at) }}
            </div>
            <div class="col-6 col-md-6 col-sm-6 col-xs-6">
              {{ item.viagens_realizadas }}
            </div>
          </div>
        </div>
      </div>
      <br />
      <div class="box box-primary">
        <div class="box-header">
          <i class="fas fa-clipboard"></i>
          <h3 class="box-title">Histórico</h3>
        </div>
        <div class="box-body">
          <ul class="todo-list" id="lista-historico">
            <li v-for="item in historico_items" v-bind:key="item.cd_historico">
              <small class="text-muted pull-right">{{
                formatarData(item.created_at)
              }}</small>
              <label class="label label-info" style="margin-left: 0px">{{
                item.createdByUsuario.nome
              }}</label>
              <br />
              {{ item.observacao }}
            </li>
          </ul>
        </div>
      </div>
    </div>

    <modal
      name="modal-imagem"
      :adaptive="false"
      width="600"
      height="95%"
      style="top: 0px"
    >
      <div class="modal-content">
        <button
          type="button"
          class="close"
          @click="$modal.hide('modal-imagem')"
          style="padding-right: 10px; padding-top: 5px;"
        >
          <span aria-hidden="true">×</span>
        </button>
        <b-img
          v-bind:src="`${imagemPerfil}`"
          fluid-grow
          class="center-block"
          style="height: -webkit-fill-available; padding: 5px;"
        ></b-img>
      </div>
    </modal>

    <modal name="modal-motorista" :adaptive="false" width="600" height="auto">
      <div class="modal-content">
        <div class="modal-header">
          <button
            type="button"
            class="close"
            @click="$modal.hide('modal-motorista')"
          >
            <span aria-hidden="true">×</span>
          </button>
          <h3 class="modal-title">{{ titleModal }}</h3>
        </div>
        <div class="modal-body" style="overflow-y: auto;">
          <div v-show="errorMessageModal != ''" class="alert alert-danger">
            {{ errorMessageModal }}
          </div>
          <div>
            {{ bodyModalSup }}
          </div>
          {{ bodyModal }}
          <div v-show="!isModalAprovar && !isModalPreAprovar && !isLinkTermo">
            <label v-show="isModalPendencia" for="historico_motivo"
              >Motivo <sup class="text-danger">* </sup></label
            >
            <select
              v-show="isModalPendencia"
              id="historico_motivo"
              v-model="historico_motivo"
              style="width: auto"
              class="form-control"
              v-bind:class="{ 'box-input-required': errors.historico_motivo }"
            >
              <option
                v-for="item in motivos_pendencia"
                v-bind:key="item.cd_motivo"
                v-bind:value="item.cd_motivo"
                >{{ item.descricao }}</option
              >
            </select>
            <span
              v-show="errors.historico_motivo != null"
              class="help-inline"
              >{{ errors.historico_motivo }}</span
            >
            <br />
            <label for="historico"
              >Observação
              <sup class="text-danger" v-show="!isModalPerfil">* </sup></label
            >
            <textarea
              id="historico"
              rows="4"
              v-model="historico"
              class="form-control"
              v-bind:class="{ 'box-input-required': errors.historico }"
            ></textarea>
            <span v-show="errors.historico != null" class="help-inline">{{
              errors.historico
            }}</span>
          </div>
        </div>
        <div class="modal-footer">
          <button
            type="button"
            class="btn btn-default pull-left"
            @click="$modal.hide('modal-motorista')"
          >
            Cancelar
          </button>
          <button
            type="button"
            class="btn btn-primary"
            @click="modalConfirma()"
            v-show="!isModalPerfil && !isLinkTermo"
          >
            Confirmar
          </button>
          <button
            type="button"
            class="btn btn-danger"
            @click="avaliarPerfilReprovar()"
            v-show="isModalPerfil"
          >
            Reprovar
          </button>
          <button
            type="button"
            class="btn btn-success"
            @click="avaliarPerfilAprovar()"
            v-show="isModalPerfil"
          >
            Aprovar
          </button>
          <button
            type="button"
            class="btn btn-success"
            @click="copiarLinkAceiteTermos()"
            v-show="isLinkTermo"
          >
            Copiar
          </button>
        </div>
      </div>
    </modal>

    <modal name="modal-equipamento" :adaptive="false" width="600" height="auto">
      <div class="modal-content">
        <div class="modal-header">
          <button
            type="button"
            class="close"
            @click="$modal.hide('modal-equipamento')"
          >
            <span aria-hidden="true">×</span>
          </button>
          <h3 class="modal-title">{{ titleModal }}</h3>
        </div>
        <div class="modal-body">
          <div v-show="errorMessageModal != ''" class="alert alert-danger">
            {{ errorMessageModal }}
          </div>
          {{ bodyModal }}
          <br /><br />
          <div v-show="!isVincular">
            <label for="historico_motivo">Destino do equipamento: <sup class="text-danger">* </sup></label>
            <select
              id="equipamento_idc_status"
              v-model="equipamento_idc_status"
              style="width: auto; display: inline-flex;"
              class="form-control"
              v-bind:class="{ 'box-input-required': errors.equipamento_idc_status }"
            >
              <option value="1">Ativação</option>
              <option value="3">Disponível no Ponto de Apoio</option>
              <option value="5">Inativo</option>
            </select>
            <br />
            <span v-show="errors.equipamento_idc_status != null" class="help-inline">{{ errors.equipamento_idc_status }}</span>
            <br /><br />
            <div v-show="equipamento_idc_status && parseInt(equipamento_idc_status) === 3">
              <label for="equipamento_cd_ponto_apoio">Ponto de Apoio: <sup class="text-danger">* </sup></label>
              <select
                id="equipamento_cd_ponto_apoio"
                v-model="equipamento_cd_ponto_apoio"
                style="width: auto; display: inline-flex;"
                class="form-control"
                v-bind:class="{ 'box-input-required': errors.equipamento_cd_ponto_apoio }"
              >
                <option
                  v-for="item in pontos"
                  v-bind:value="item.cd_ponto_apoio"
                  v-bind:key="item.cd_ponto_apoio"
                >
                  {{ item.cd_ponto_apoio }}
                </option>
              </select>
              <br />
              <span
                v-show="errors.equipamento_cd_ponto_apoio != null"
                class="help-inline"
                >{{ errors.equipamento_cd_ponto_apoio }}</span
              >
            </div>
          </div>
          <div v-show="isVincular">
            <label for="equipamento_player">Código Player: </label>
            <input
              id="equipamento_player"
              v-model="equipamento_player"
              v-mask="'#.#####'"
              placeholder="#.#####"
              type="text"
              style="width: auto; display: inline-flex;"
              class="form-control"
              v-bind:class="{ 'box-input-required': errors.equipamento_player }"
            />
            <span
              v-show="errors.equipamento_player != null"
              class="help-inline"
              >{{ errors.equipamento_player }}</span
            >
          </div>
        </div>
        <div class="modal-footer">
          <button
            type="button"
            class="btn btn-default pull-left"
            @click="$modal.hide('modal-equipamento')"
          >
            Cancelar
          </button>
          <button
            type="button"
            class="btn btn-primary"
            @click="modalEquipamentoConfirma()"
          >
            Confirmar
          </button>
        </div>
      </div>
    </modal>

    <modal name="modal-agendamento" :adaptive="false" width="600" height="400">
      <div class="modal-content" style="height: 400px; display: flex; flex-direction: column;">
        <div class="modal-header">
          <button
            type="button"
            class="close"
            @click="$modal.hide('modal-agendamento')"
          >
            <span aria-hidden="true">×</span>
          </button>
          <h3 class="modal-title">{{ titleModal }}</h3>
        </div>
        <div class="modal-body">
          <div v-show="errorMessageModal != ''" class="alert alert-danger">
            {{ errorMessageModal }}
          </div>

          <div class="row">
            <div class="form-group col-12 col-md-6">
              <label for="idc_status">Status <sup class="text-danger">* </sup></label>
              <select
                v-model="agendamento.idc_status"
                style="width: auto"
                class="form-control"
                v-bind:class="{ 'box-input-required': errors_agendamento.idc_status }"
              >
                <option value="1">Aguardando Agendamento</option>
                <option value="2">Agendado</option>
                <option value="3">Em Andamento</option>
                <option value="4">Finalizado</option>
                <option value="5">Não Executado</option>
                <option value="9">Cancelado</option>
              </select>
              <span v-show="errors_agendamento.idc_status != null" class="help-inline">{{ errors_agendamento.idc_status }}</span>
            </div>
            <div class="form-group col-12 col-md-6">
              <label for="cd_ponto_apoio">Ponto de Apoio <sup class="text-danger">* </sup></label>
              <select
                v-model="agendamento.cd_ponto_apoio"
                style="width: auto"
                class="form-control"
                v-bind:class="{ 'box-input-required': errors_agendamento.cd_ponto_apoio }"
              >
                <option v-for="item in pontos" v-bind:key="item.cd_ponto_apoio" v-bind:value="item.cd_ponto_apoio">
                  {{ item.cd_ponto_apoio }}
                </option>
              </select>
              <span v-show="errors_agendamento.cd_ponto_apoio != null" class="help-inline">{{ errors_agendamento.cd_ponto_apoio }}</span>
            </div>
          </div>
          <div class="row">
            <div class="form-group col-12 col-md-6">
              <label>Data Agendada <sup class="text-danger">* </sup></label>
              <vue-pikaday
                class="form-control"
                autocomplete="off"
                style="width: 200px"
                v-model="agendamento.dt_agendada"
                placeholder="dd/mm/aaaa"
                :options="pikadayOptions"
                v-bind:class="{ 'box-input-required': errors_agendamento.dt_prevista }"
              />
              <span v-show="errors_agendamento.dt_agendada != null" class="help-inline">{{ errors_agendamento.dt_agendada }}</span>
            </div>
            <div class="form-group col-12 col-md-6">
              <label>Horário Agendado <sup class="text-danger">* </sup></label>
              <vue-timepicker
                style="width: 200px;"
                v-model="agendamento.hr_agendado"
                v-bind:class="{ 'box-input-required': errors_agendamento.hr_agendado }"
                hide-clear-button
              />
              <span v-show="errors_agendamento.hr_agendado != null" class="help-inline">{{ errors_agendamento.hr_agendado }}</span>
            </div>
          </div>
        </div>
        <div class="modal-footer" style="margin-top: auto;">
          <button
            type="button"
            class="btn btn-default pull-left"
            @click="$modal.hide('modal-agendamento')"
          >
            Cancelar
          </button>
          <button
            type="button"
            class="btn btn-primary"
            @click="modalAgendamentoConfirma()"
          >
            Confirmar
          </button>
        </div>
      </div>
    </modal>

    <modal
      name="modal-erro"
      :adaptive="false"
      width="600"
      height="auto"
      class="modal-danger"
    >
      <div class="modal-content">
        <div class="modal-header">
          <button
            type="button"
            class="close"
            @click="$modal.hide('modal-erro')"
          >
            <span aria-hidden="true">×</span>
          </button>
          <h3 class="modal-title">{{ titleModal }}</h3>
        </div>
        <div class="modal-body">
          <div v-html="bodyModal"></div>
        </div>
        <div class="modal-footer">
          <button
            type="button"
            class="btn btn-default"
            @click="$modal.hide('modal-erro')"
          >
            Fechar
          </button>
        </div>
      </div>
    </modal>
  </div>
</template>

<script>
/* eslint-disable */
import { formatCpf } from "@brazilian-utils/formatters";
import moment from "moment";
import AgendamentoActions from "../../actions/AgendamentoActions";
import ApuracaoMensalActions from "../../actions/ApuracaoMensalActions";
import MotoristaAceiteTermoActions from "../../actions/MotoristaAceiteTermoActions";
import MotoristaActions from "../../actions/MotoristaActions";
import MotoristaAplicativoActions from "../../actions/MotoristaAplicativoActions";
import MotoristaHistoricoActions from "../../actions/MotoristaHistoricoActions";
import MotoristaPendenciaMotivoActions from "../../actions/MotoristaPendenciaMotivoActions";
import PontoApoioActions from "../../actions/PontoApoioActions";
import Formatters from "../../helpers/Formatters";
import * as FormInputOptions from './../../helpers/FormInputOptions';

export default {
  name: "detalhes",
  props: ["id"],
  data() {
    return {
      titleModal: "Reprovar Motorista",
      bodyModal: "",
      bodyModalSup: "",
      isModalPendencia: false,
      isModalPerfil: false,
      isModalAprovar: false,
      isModalPreAprovar: false,
      isLinkTermo: false,
      isVincular: false,
      linkAceiteTermo: "",
      imagemPerfil: "",
      errorMessageModal: "",
      errors: {},
      showModalLoader: 0,
      registro: {
        nome: "",
        email: "",
        cpf: "",
        tel_celular: "",
        end_cep: "",
        end_logradouro: "",
        end_numero: "",
        end_complemento: "",
        end_bairro: "",
        end_cidade: "",
        end_uf: "",
        end_pais: "",
        end_latitude: "",
        end_longitude: "",
        idc_status: "",
        idc_termo_aceito: "",
        idc_equipamento: "",
        status_desc: "",
        termo_aceito_desc: "",
        idc_equipamento_desc: "",
        pais: {
          descricao: ""
        },
        complemento: null
      },
      aplicativos: [],
      agendamentos: [],
      historico: null,
      historico_motivo: null,
      historico_items: [],
      aceite_termo_items: [],
      motivos_pendencia: [],
      historico_apuracao: [],
      pontos: [],
      equipamento_idc_status: null,
      equipamento_cd_ponto_apoio: null,
      equipamento_player: null,
      pikadayOptions: FormInputOptions.PikadayOptions,
      errors_agendamento: {},
      agendamento: {
        idc_status: 2,
        cd_ponto_apoio: null,
        dt_agendada: null,
        hr_agendado: null
      }
    };
  },
  mounted() {
    this.$parent.$parent.$data.description = "Detalhes";
    this.$parent.$parent.$data.showModalLoader = true;

    this.obterMotorista();
    this.obterMotoristaAplicativo();
    this.listarHistoricoPorMotorista();
    this.listarAceiteTermoPorMotorista();
    this.listarMotivosAtivos();
    this.listarHistoricoApuracao();
    this.listarAgendamentos();
  },
  watch: {
    showModalLoader: function(val) {
      if (val === 0) {
        this.$parent.$parent.$data.showModalLoader = false;
      }
    }
  },
  methods: {
    voltar() {
      this.$router.push(
        this.$route.query.ret_url ? this.$route.query.ret_url : "/motoristas"
      );
    },
    editar() {
      this.$router.push("/motoristas/" + this.id + "/e");
    },
    editarComplemento() {
      this.$router.push({
        path: "/motoristas/" + this.id + "/complemento/e",
        query: { ret_url: this.$route.query.ret_url }
      });
    },
    editarAplicativo(aplicativo) {
      if (aplicativo === "new") {
        this.$router.push({
          path: "/motoristas/" + this.id + "/aplicativo/" + aplicativo,
          query: { ret_url: this.$route.query.ret_url }
        });
      } else {
        this.$router.push({
          path: "/motoristas/" + this.id + "/aplicativo/" + aplicativo + "/e",
          query: { ret_url: this.$route.query.ret_url }
        });
      }

      return aplicativo;
    },
    obterMotorista() {
      this.showModalLoader++;

      MotoristaActions
        .obterMotorista(this.id)
        .then(motorista => {
          if (motorista && motorista.nome) {
            this.registro = motorista;

            this.registro.cpf = formatCpf(this.registro.cpf);
            this.registro.tel_celular = Formatters.formataNumeroTelefone(this.registro.tel_celular);
            this.registro.end_cep = Formatters.formataCep(this.registro.end_cep);
            this.registro.pais = this.registro.pais === null ? { descricao: null } : this.registro.pais;

            if (motorista.complemento) {
              this.registro.complemento.veiculo = 
                (motorista.complemento.veiculoFabricante ? motorista.complemento.veiculoFabricante.descricao : "-")
                  + ` / ${motorista.complemento.veiculo_modelo} / ${motorista.complemento.veiculo_ano}`
                  + (motorista.complemento.veiculo_placa ? ` / ${motorista.complemento.veiculo_placa}` : '')
            }
          } else {
            this.errorMessage = "Registro não encontrado.";
          }

          this.showModalLoader--;
        })
        .catch(() => {
          this.errorMessage = "Registro não encontrado.";
          this.showModalLoader--;
        });
    },
    obterMotoristaAplicativo() {
      this.showModalLoader++;

      MotoristaAplicativoActions
        .obterMotoristaAplicativo(this.id)
        .then(res => {
          this.aplicativos = res;
          this.showModalLoader--;
        })
        .catch(() => {
          this.showModalLoader--;
        });
    },
    listarHistoricoPorMotorista() {
      this.showModalLoader++;

      MotoristaHistoricoActions
        .listarHistoricoPorMotorista(this.id)
        .then(res => {
          this.historico_items = res;
          this.showModalLoader--;
        })
        .catch(() => {
          this.showModalLoader--;
        });
    },
    listarAgendamentos() {
      this.showModalLoader++;

      AgendamentoActions
        .listarPorMotorista(this.id)
        .then(res => {
          this.agendamentos = res;
          this.showModalLoader--;
        })
        .catch(() => {
          this.showModalLoader--;
        });
    },
    listarAceiteTermoPorMotorista() {
      this.showModalLoader++;

      MotoristaAceiteTermoActions
        .listarAceiteTermoPorMotorista(this.id)
        .then(res => {
          this.aceite_termo_items = res;
          this.showModalLoader--;
        })
        .catch(() => {
          this.showModalLoader--;
        });
    },
    listarHistoricoApuracao() {
      this.showModalLoader++;

      ApuracaoMensalActions
        .listarHistoricoPorMotorista(this.id)
        .then(res => {
          this.historico_apuracao = res;
          this.showModalLoader--;
        })
        .catch(() => {
          this.showModalLoader--;
        });
    },
    listarMotivosAtivos() {
      this.showModalLoader++;
      
      MotoristaPendenciaMotivoActions.listarMotivosAtivos()
        .then(res => {
          this.motivos_pendencia = res;
          this.showModalLoader--;
        })
        .catch(() => {
          this.showModalLoader--;
        });
    },
    abrirImagem(imgemPerfil) {
      this.titleModal = "Imagem Perfil";
      this.bodyModalSup = "";
      this.bodyModal = "";
      this.isModalPendencia = false;
      this.isModalPerfil = false;
      this.isModalAprovar = false;
      this.isModalPreAprovar = false;
      this.isLinkTermo = false;
      this.errorMessageModal = "";
      this.errors = {};
      this.imagemPerfil = MotoristaAplicativoActions.getUrlImagem(imgemPerfil);
      this.$modal.show("modal-imagem");
    },
    avaliarPerfil(cdAplicativo) {
      this.titleModal = "Avaliar Perfil";
      this.bodyModalSup = "";
      this.bodyModal = "";
      this.isModalPendencia = false;
      this.isModalPerfil = true;
      this.isModalAprovar = false;
      this.isModalPreAprovar = false;
      this.isLinkTermo = false;
      this.historico = "";
      this.errorMessageModal = "";
      this.errors = {};
      this.cd_aplicativo = cdAplicativo;
      this.$modal.show("modal-motorista");
    },
    avaliarPerfilAprovar() {
      this.$parent.$parent.$data.showModalLoader = true;
      this.showModalLoader++;

      MotoristaAplicativoActions
        .aprovarPerfil({
          cd_motorista: this.id,
          cd_aplicativo: this.cd_aplicativo,
          observacao: this.historico
        })
        .then(() => {
          this.$modal.hide("modal-motorista");
          this.obterMotoristaAplicativo();
          this.showModalLoader--;
        })
        .catch(() => {
          this.errorMessageModal = "Ocorreu um erro ao gravar o registro.";
          this.showModalLoader--;
        });
    },
    avaliarPerfilReprovar() {
      this.$parent.$parent.$data.showModalLoader = true;
      this.showModalLoader++;

      MotoristaAplicativoActions
        .reprovarPerfil({
          cd_motorista: this.id,
          cd_aplicativo: this.cd_aplicativo,
          observacao: this.historico
        })
        .then(() => {
          this.$modal.hide("modal-motorista");
          this.obterMotorista();
          this.obterMotoristaAplicativo();
          this.showModalLoader--;
        })
        .catch(() => {
          this.errorMessageModal = "Ocorreu um erro ao gravar o registro.";
          this.showModalLoader--;
        });
    },
    gerarLinkAceiteTermo() {
      MotoristaActions.gerarUrlTokenAceiteTermos(this.id)
        .then(result => {
          if (result) {
            this.linkAceiteTermo = result.url;
            this.titleModal = "Link Aceite Termos";
            this.bodyModalSup = `Valido até: ${this.formatarData(result.expiration)}`;
            this.bodyModal = `Link: ${this.linkAceiteTermo}`;
            this.isModalPendencia = false;
            this.isModalPerfil = false;
            this.isModalAprovar = false;
            this.isModalPreAprovar = false;
            this.isLinkTermo = true;
            this.historico = "";
            this.errorMessageModal = "";
            this.errors = {};
            this.$modal.show("modal-motorista");
          }
        });
    },
    async copiarLinkAceiteTermos() {
      try {
        await navigator.clipboard.writeText(this.linkAceiteTermo);
      } catch (err) {
        console.error('Erro ao copiar: ', err);
      }
    },
    alterarPendente() {
      this.titleModal = "Alterar Motorista p/ Pendente";
      this.bodyModalSup = "";
      this.bodyModal = "";
      this.isModalPendencia = true;
      this.isModalPerfil = false;
      this.isModalAprovar = false;
      this.isModalPreAprovar = false;
      this.isLinkTermo = false;
      this.historico = "";
      this.errorMessageModal = "";
      this.errors = {};
      this.$modal.show("modal-motorista");
    },
    alterarPendenteConfirma() {
      this.errors = {};
      let hasError = false;
      
      if (!this.historico) {
        this.errors.historico = "Este campo deve ser preenchido.";
        hasError = true;
      }

      if (!this.historico_motivo) {
        this.errors.historico_motivo = "Este campo deve ser preenchido.";
        hasError = true;
      }

      if (!hasError) {
        MotoristaHistoricoActions
          .gravarHistorico({
            cd_motorista: this.id,
            observacao: this.historico,
            cd_status_motorista: 11,
            cd_motivo_pendencia: this.historico_motivo
          })
          .then(res => {
            if (res && res.data.cd_historico) {
              MotoristaActions.alterarParaPendenciaMotorista(this.id)
                .then(res => {
                  if (res && res.nome) {
                    this.$modal.hide("modal-motorista");
                    this.registro.idc_status = res.idc_status;
                    this.registro.status_desc = res.status_desc;
                    this.listarHistoricoPorMotorista();
                  }
                })
                .catch(() => {
                  this.errorMessage = "Ocorreu um erro ao gravar o registro.";
                });
            }
          })
          .catch(() => {
            this.errorMessageModal = "Ocorreu um erro ao gravar o registro.";
          });
      }
    },
    preAprovar() {
      this.titleModal = "Pré-aprovar Motorista";
      this.bodyModalSup = "";
      this.bodyModal =
        "Deseja PRÉ-APROVAR este motorista? Isso irá liberar o motorista para enviar as imagens de perfil, após envio ele estará disponível para avaliação.";
      this.isModalPendencia = false;
      this.isModalPerfil = false;
      this.isModalAprovar = false;
      this.isModalPreAprovar = true;
      this.isLinkTermo = false;
      this.historico = "";
      this.errorMessageModal = "";
      this.errors = {};
      this.$modal.show("modal-motorista");
    },
    aprovar() {
      this.titleModal = "Aprovar Motorista";
      this.bodyModalSup = "";
      this.bodyModal = "Deseja APROVAR este motorista?";
      this.isModalPendencia = false;
      this.isModalPerfil = false;
      this.isModalAprovar = true;
      this.isModalPreAprovar = false;
      this.isLinkTermo = false;
      this.historico = "";
      this.errorMessageModal = "";
      this.errors = {};
      this.$modal.show("modal-motorista");
    },
    reprovar() {
      this.titleModal = "Reprovar Motorista";
      this.bodyModalSup = "";
      this.bodyModal = "";
      this.isModalPendencia = false;
      this.isModalPerfil = false;
      this.isModalAprovar = false;
      this.isModalPreAprovar = false;
      this.isLinkTermo = false;
      this.historico = "";
      this.errorMessageModal = "";
      this.errors = {};
      this.$modal.show("modal-motorista");
    },
    reprovarConfirma() {
      this.errors = {};

      if (!this.historico) {
        this.errors.historico = "Este campo deve ser preenchido.";
      } else {
        MotoristaHistoricoActions
          .gravarHistorico({
            cd_motorista: this.id,
            observacao: this.historico,
            cd_status_motorista: 2,
            cd_motivo_pendencia: null
          })
          .then(res => {
            if (res && res.data.cd_historico) {
              MotoristaActions.reprovarMotorista(this.id)
                .then(res => {
                  if (res && res.nome) {
                    this.$modal.hide("modal-motorista");
                    this.registro.idc_status = res.idc_status;
                    this.registro.status_desc = res.status_desc;
                    this.listarHistoricoPorMotorista();
                  }
                })
                .catch(() => {
                  this.errorMessage = "Ocorreu um erro ao gravar o registro.";
                });
            }
          })
          .catch(() => {
            this.errorMessageModal = "Ocorreu um erro ao gravar o registro.";
          });
      }
    },
    aprovarConfirma() {
      MotoristaActions.aprovarMotorista(this.id)
        .then(res => {
          if (res && res.nome) {
            this.$modal.hide("modal-motorista");
            this.registro.idc_status = res.idc_status;
            this.registro.status_desc = res.status_desc;
          }
        })
        .catch(() => {
          this.errorMessage = "Ocorreu um erro ao gravar o registro.";
        });
    },
    preAprovarConfirma() {
      MotoristaActions.preAprovarMotorista(this.id)
        .then(res => {
          if (res && res.nome) {
            this.$modal.hide("modal-motorista");
            this.registro.idc_status = res.idc_status;
            this.registro.status_desc = res.status_desc;
          }
        })
        .catch(() => {
          this.errorMessage = "Ocorreu um erro ao gravar o registro.";
        });
    },
    modalConfirma() {
      if (this.isModalPendencia) {
        this.alterarPendenteConfirma();
      } else if (this.isModalAprovar) {
        this.aprovarConfirma();
      } else if (this.isModalPreAprovar) {
        this.preAprovarConfirma();
      } else {
        this.reprovarConfirma();
      }
    },
    formatarData(data, usaHora = true) {
      const date = moment(data);
      
      if (date.isValid()) {
        return usaHora ? date.format("DD/MM/YYYY HH:mm:ss") : date.format("DD/MM/YYYY");
      }

      return "";
    },
    abrirEquipamento(equipamento) {
      this.$router.push("/equipamentos/" + equipamento);
    },
    vincularEquipamento() {
      const ativos = this.registro.motorista_equipamento.filter(item => item.idc_status === 1);
      
      if (ativos && ativos.length > 0) {
        this.titleModal = "Erro";
        this.bodyModalSup = "";
        this.bodyModal = "Motorista já possui um equipamento ativo.";
        this.$modal.show("modal-erro");
      } else {
        this.titleModal = "Vincular equipamento";
        this.bodyModalSup = "";
        this.bodyModal = "Informe o código do player que deseja vincular.";
        this.isVincular = true;
        this.errorMessageModal = "";
        this.errors = {};
        this.equipamento_player = null;
        this.$modal.show("modal-equipamento");
      }
    },
    removerEquipamento(equipamento, player) {
      this.titleModal = "Remover equipamento";
      this.bodyModalSup = "";
      this.bodyModal = "Deseja remover o equipamento " + player + " deste motorista?";
      this.isVincular = false;
      this.errorMessageModal = "";
      this.errors = {};
      this.equipamento_cd_desativar = equipamento;
      this.equipamento_idc_status = null;
      this.equipamento_cd_ponto_apoio = null;

      PontoApoioActions.listarPontoApoioAtivos().then(res => {
        this.pontos = res;
      });

      this.$modal.show("modal-equipamento");
    },
    modalEquipamentoConfirma() {
      if (this.isVincular) {
        this.vincularEquipamentoConfirma();
      } else {
        this.removerEquipamentoConfirma();
      }
    },
    removerEquipamentoConfirma() {
      this.errors = {};
      let hasError = false;

      if (!this.equipamento_idc_status) {
        this.errors.equipamento_idc_status = "Este campo deve ser preenchido.";
        hasError = true;
      }

      if (parseInt(this.equipamento_idc_status) === 3 && !this.equipamento_cd_ponto_apoio) {
        this.errors.equipamento_cd_ponto_apoio = "Este campo deve ser preenchido.";
        hasError = true;
      }

      if (!hasError) {
        this.$parent.$parent.$data.showModalLoader = true;

        MotoristaActions
          .desativarMotoristaEquipamento(
            this.id,
            this.equipamento_cd_desativar,
            this.equipamento_idc_status,
            this.equipamento_cd_ponto_apoio
          )
          .then(() => {
            this.$parent.$parent.$data.showModalLoader = false;
            this.$modal.hide("modal-equipamento");
            this.obterMotorista();
          })
          .catch(() => {
            this.errorMessageModal = "Ocorreu um erro ao alterar o registro.";

            this.$parent.$parent.$data.showModalLoader = false;
          });
      }
    },
    vincularEquipamentoConfirma() {
      this.errors = {};
      let hasError = false;

      if (!this.equipamento_player) {
        this.errors.equipamento_player = "Este campo deve ser preenchido.";
        hasError = true;
      }

      if (!hasError) {
        this.$parent.$parent.$data.showModalLoader = true;

        MotoristaActions
          .vincularMotoristaEquipamento(
            this.id,
            this.equipamento_player
          )
          .then(() => {
            this.$parent.$parent.$data.showModalLoader = false;
            this.$modal.hide("modal-equipamento");
            this.obterMotorista();
          })
          .catch(error => {
            this.errorMessageModal = error.response.data.error;
            this.$parent.$parent.$data.showModalLoader = false;
          });
      }
    },
    novoAgendamento() {
      const possuiAgendamento = this.agendamentos.filter(i => [2, 3].includes(i.idc_status));
      
      if (possuiAgendamento && possuiAgendamento.length > 0) {
        this.titleModal = "Erro";
        this.bodyModalSup = "";
        this.bodyModal = "Motorista já possui um agendamento ativo.";

        this.$modal.show("modal-erro");
      } else {
        this.titleModal = "Novo Agendamento";
        this.errorMessageModal = "";
        this.errors_agendamento = {};

        PontoApoioActions.listarPontoApoioAtivos().then(res => {
          this.pontos = res;
        });

        this.$modal.show("modal-agendamento");
      }
    },
    modalAgendamentoConfirma() {
      this.errors_agendamento = {};
      let hasError = false;

      const camposValidar = ["idc_status", "cd_ponto_apoio", "dt_agendada", "hr_agendado"];

      camposValidar.forEach(i => {
        if (!this.agendamento[i]) {
          this.errors[i] = "Este campo deve ser preenchido.";
          hasError = true;
        }
      });

      if (!hasError) {
        this.$parent.$parent.$data.showModalLoader = true;

        this.agendamento.dt_agendada.setHours(this.agendamento.hr_agendado.HH);
        this.agendamento.dt_agendada.setMinutes(this.agendamento.hr_agendado.mm);

        AgendamentoActions
          .criarAgendamento({
            cd_motorista: this.id,
            cd_ponto_apoio: this.agendamento.cd_ponto_apoio,
            idc_status: this.agendamento.idc_status,
            dt_agendada: this.agendamento.dt_agendada
          })
          .then(() => {
            this.listarAgendamentos();
            this.$modal.hide("modal-agendamento");
          })
          .catch(error => {
            this.errorMessageModal = error.response.data.error;
            this.$parent.$parent.$data.showModalLoader = false;
          });
      }
    },
    editarAgendamento(cd_agendamento) {
      this.$router.push({
        path: `/agendamentos/${cd_agendamento}/e`,
        query: { ret_url: `/motoristas/${this.id}` }
      });
    },
  }
};
</script>



// WEBPACK FOOTER //
// src/pages/motorista/Detalhes.vue